import React from 'react';
import { Box, Package, Sparkles } from 'lucide-react';
import { included, lifestyleImages } from '../mock';

const iconMap = {
  glasses: () => (
    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  box: Box,
  package: Package,
  sparkles: Sparkles
};

export const Included = () => {
  return (
    <section id="incluye" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            Todo lo que recibes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Cada par incluye gafas oficiales de La Tri, caja rígida, funda y paño de limpieza 
            para que las tengas siempre como nuevas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {included.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div 
                key={item.id}
                className="group text-center p-6 rounded-2xl hover:bg-blue-50 transition-all duration-300"
              >
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all shadow-lg">
                  {typeof Icon === 'function' ? <Icon /> : <Icon className="text-white" size={40} strokeWidth={2.5} />}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>

        {/* Visual Section with Image */}
        <div className="mt-20 grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img 
              src={lifestyleImages.family} 
              alt="Familia disfrutando el partido con Gafas La Tri"
              className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/5]"
             loading="lazy" decoding="async" />
            <div className="absolute -bottom-4 -right-4 bg-yellow-400 text-blue-900 rounded-2xl shadow-xl px-6 py-3 font-bold">
              Para toda la familia
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Empaque premium que protege tu inversión</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Caja oficial de Federación Ecuatoriana</h4>
                  <p className="text-gray-600">Empaque azul/amarillo con #HacerHistoriaConLaTri</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Funda de microfibra</h4>
                  <p className="text-gray-600">Suave y protectora para el día a día</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Paño de limpieza premium</h4>
                  <p className="text-gray-600">Mantén tus lentes impecables siempre</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Producto 100% oficial FEF</h4>
                  <p className="text-gray-600">Licencia oficial de la Federación Ecuatoriana de Fútbol</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Included;
